/**
 * Shared B2B Events Data
 * This file contains the events data used across B2B components
 */

export interface B2BEvent {
  id: number;
  date: string;
  eventDate: string; // ISO date format for comparison
  title: string;
  description: string;
  location: string;
  time: string;
  category: string;
  price: string;
  registrationLink: string;
  capacity: string;
  registered: string;
  featured: boolean;
  speakers: string[];
  topics: string[];
}

export const B2B_EVENTS: B2BEvent[] = [
  {
    id: 1,
    date: "6 октября",
    eventDate: "2024-10-06", // ISO date format for comparison
    title: "Валютные инвестиции и налоговое планирование в ОАЭ",
    description:
      "Закрытый вебинар для владельцев капитала и частных инвесторов специально для сообщества British Chic",
    location: "Онлайн вебинар",
    time: "13:00 Лондон | 16:00 Дубай",
    category: "Инвестиции",
    price: "Бесплатно",
    registrationLink: "https://webinar.tranio.ru/chic",
    capacity: "Ограничено",
    registered: "Регистрация открыта",
    featured: true,
    speakers: [
      "Илья Антипов, управляющий партнёр Tranio Capital",
      "Антон Ионов, управляющий партнёр Phoenix Partners",
      "Модератор: Михаил Буланов, Tranio",
    ],
    topics: [
      "Как участие в девелоперских проектах Дубая на раннем этапе помогает формировать доходность ~15% годовых в валюте (Tranio Capital)",
      "Какие налоговые правила и требования действуют для инвесторов и компаний в ОАЭ (Phoenix Partners)",
    ],
  },
];

/**
 * Check if an event date is in the past
 * @param eventDate - ISO date string (e.g., "2024-10-06")
 * @returns true if event date is in the past
 */
export const isEventExpired = (eventDate: string | undefined): boolean => {
  if (!eventDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const event = new Date(eventDate);
  event.setHours(0, 0, 0, 0);
  return event < today;
};

